import dayjs from 'dayjs';
import React, { FC, useState } from 'react';
import DatePicker from 'react-multi-date-picker';
import { toast } from 'react-toastify';
import cnBind from 'classnames/bind';
import { GxIcon } from '@garpix/garpix-web-components-react';
import 'react-responsive-modal/styles.css';
import Button from '../../../../../../components/Button';
import CalendarInput from '../../../../../../components/CalendarInput';
import Select from '../../../../../../components/Select';
import { months, weekDays } from '../../../../../../const/calendar';
import { statusOptions2, TYPES_STATUS } from '../../../../consts';
import styles from '../../styles/index.module.scss';
import { handleClickLoadOrders } from '../../helpers';
import { AnketaIcon } from '../../../../../../assets';

interface IStatisticSortMenu {
  filterParams?: Record<string, any>
  loadData?: any,
  isDisabled?: boolean,
}

const StatisticSortMenu: FC<IStatisticSortMenu> = ({ filterParams, loadData, isDisabled }) => {
  const [date, setDate] = useState<any>();
  const cn = cnBind.bind(styles);
  const [activeItem, setActiveItem] = useState<number>(1);

  const handleAddDate = (date: any) => {
    if (date[0]) {
      loadData(1, {
        ...filterParams,
        start_date: date[0].format('YYYY-MM-DD'),
        end_date: date.length > 1 ? date[1].format('YYYY-MM-DD') : date[0].format('YYYY-MM-DD')
      });
      setDate(date);
    }
  };

  const handleRemoveDate = () => {
    setDate('');
    loadData(1, {
      ...filterParams,
      start_date: '',
      end_date: ''
    });
  };
  const handleClickSide = (id: number) => {
    setActiveItem(id);
    loadData(1, {
      ...filterParams,
      side: id
    });
  };
  const update = () => {
    loadData(1, {
      ...filterParams,
      side: activeItem
    })
  }

  /**
   * TODO типизировать
   */
  const loadOrders = async () => {
    try {
      const res = await handleClickLoadOrders({
        id: filterParams ? filterParams.customer : undefined,
        date_from: filterParams ? filterParams.start_date : undefined,
        date_to: filterParams 
        ? dayjs(filterParams.end_date).isSame(dayjs(filterParams.start_date)) 
          ?dayjs(filterParams.start_date).format('YYYY-MM-DD') 
          : filterParams.end_date 
        : undefined,
        statuses:
          filterParams ?
            filterParams.status ?
              [filterParams.status]
              :
              [
                TYPES_STATUS.PAY_LOAD,
                TYPES_STATUS.PAY_LOCAL,
                TYPES_STATUS.PAY_SUCCESS,
                TYPES_STATUS.PAY_PARTLY,
                TYPES_STATUS.CLOSE
              ]
            :
            undefined,
        side: filterParams ? filterParams.side : undefined
      });

      const downloadUrl = res?.link;

      toast(
        <a className={styles['toast-info']} target='_blank' rel="noreferrer" href={downloadUrl} download='orders.xlsx' >
          <GxIcon src={AnketaIcon} className={styles['toast-info--icon']} />
          <span className={styles['toast-info--text']}>Выгрузка от {filterParams ? filterParams.start_date : 'н.д'}</span>
        </a>,
        {
          position: 'top-right',
          autoClose: false,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          onClose: () => {
            URL.revokeObjectURL(downloadUrl)
          }
        }
      )
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div className={styles['wrapper']}>
      <div className={styles['orders--group']}>
        <div className={styles['menu']}>
          <Select
            isDisabled={isDisabled}
            options={statusOptions2}
            defaultValue={statusOptions2[6]}
            onChange={((option: any) => loadData(1,
              { ...filterParams, ...(Number(option.value) !== 9 ? { status: option.value } : { status: '' }) }
            )
            )}
          />
        </div>
        <div className={styles['onloading']}>

          <div className={styles['onloading--date']}>
            <DatePicker
              disabled={isDisabled}
              onChange={handleAddDate}
              weekDays={weekDays}
              months={months}
              render={<CalendarInput
                clear={handleRemoveDate}
                type='sm_xl'
                value={date}
                disabled={isDisabled}
              />
              }
              weekStartDayIndex={1}
              range
              value={date}
            />
          </div>
          <Button className={styles['onloading--btn']} onClick={loadOrders}>
            Выгрузить
          </Button>
          <Button className={styles['onloading--btn']} onClick={update}>
            Обновить
          </Button>
        </div>
      </div>
      <div className={styles['sort-menu']}>
        <Button
          className={cn({
            'sort-menu--btn': true,
            'sort-menu--btn_active': activeItem === 1
          })}
          theme='btn--transparent_link'
          onClick={() => handleClickSide(1)}
        >
          Труба
        </Button>
        <Button
          className={cn({
            'sort-menu--btn': true,
            'sort-menu--btn_active': activeItem === 2
          })}
          theme='btn--transparent_link'
          onClick={() => handleClickSide(2)}
        >
          Волна
        </Button>
      </div>
    </div>
  );
};

export default StatisticSortMenu;
